/* eslint-disable react/react-in-jsx-scope */
import axios from "axios"
import { motion } from "framer-motion"
import { useEffect, useState } from "react"
import { Card, CardBody, Col, Row, Spinner } from "reactstrap"
import "./CardProcesso.css"
import formatNumber from "./formatNumber"

const oportunidadesStats = [
  {
    title: "Total de Leads Qualificados",
    key: "totalLeadsQualificados",
    icon: "bx bx-user-check",
    gradient: "linear-gradient(135deg, #53B947 0%, #169F85 100%)",
  },
  {
    title: "Valor Total de Oportunidades Mapeadas",
    key: "valorTotalOportunidadesMapeadas",
    icon: "bx bx-trending-up",
    gradient: "linear-gradient(135deg, #6B8DE3 0%, #4318FF 100%)",
  },
  {
    title: "Valor Total de IS",
    key: "valorTotalIS",
    icon: "bx bx-money",
    gradient: "linear-gradient(135deg, #49B5C0 0%, #1A97F5 100%)",
  },
  {
    title: "Valor Total de Prêmios",
    key: "valorTotalPremios",
    icon: "bx bx-coin",
    gradient: "linear-gradient(135deg, #FFAA2B 0%, #FB9678 100%)",
  },
]

const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
}

const cardVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100, damping: 12 },
  },
}

const numberVariants = {
  hidden: { scale: 0.8, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: { type: "spring", stiffness: 100 },
  },
}

const CardOportunidades = () => {
  const [oportunidadesData, setOportunidadesData] = useState({
    totalLeadsQualificados: 0,
    valorTotalOportunidadesMapeadas: 0,
    valorTotalIS: 0,
    valorTotalPremios: 0
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchOportunidadesStats = async () => {
      try {
        setLoading(true)
        const response = await axios.get(`${process.env.REACT_APP_API_EXT_LEADS}/api/processos/financial-opportunities-stats`)
        
        setOportunidadesData(response.data)
        setError(null)
      } catch (err) {
        console.error('Erro ao buscar estatísticas de oportunidades:', err)
        setError(err.response?.data?.message || err.message || 'Erro ao carregar dados')
      } finally {
        setLoading(false)
      }
    }

    fetchOportunidadesStats()
  }, [])

  const formatCurrency = (value) => {
    const numValue = Number(value) || 0
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numValue)
  }

  const isCurrencyField = (key) => {
    return key.includes('valor') || key.includes('Valor')
  }

  const renderOportunidadeValue = (key) =>
    loading ? (
      <Spinner size="sm" color="light" />
    ) : error ? (
      <span className="text-white-50">Erro</span>
    ) : isCurrencyField(key) ? (
      formatCurrency(oportunidadesData[key] || 0)
    ) : (
      formatNumber(oportunidadesData[key] || 0)
    )

  return (
    <div className="dashboard-stats">
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <Card className="shadow-lg border-0 rounded-lg">
          <CardBody>
            <Row className="mb-4">
              <Col lg="12">
                <h3 className="text-gradient fw-bold">
                  Estatísticas de Oportunidades Financeiras
                </h3>
              </Col>
            </Row>
            <Row>
              {oportunidadesStats.map(({ title, key, icon, gradient }, index) => (
                <Col lg="3" key={index}>
                  <motion.div variants={cardVariants}>
                    <Card
                      className="stat-card border-0 h-100"
                      style={{ background: gradient }}
                    >
                      <CardBody className="p-4">
                        <div className="d-flex align-items-center mb-3">
                          <div className="stat-icon me-3">
                            <span className="rounded-circle bg-white bg-opacity-10 text-white">
                              <i className={`${icon} fs-4`} />
                            </span>
                          </div>
                          <h5 className="text-white mb-0 fw-semibold">
                            {title}
                          </h5>
                        </div>
                        <div className="mt-4">
                          <motion.div
                            variants={numberVariants}
                            className="d-flex align-items-center"
                          >
                            <h2 className="text-white mb-0 me-2 fw-bold">
                              {renderOportunidadeValue(key)}
                            </h2>
                            <span className="badge bg-white bg-opacity-10 text-white">
                              {isCurrencyField(key) ? 'Valor' : 'Total'}
                            </span>
                          </motion.div>
                        </div>
                      </CardBody>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </motion.div>
    </div>
  )
}

export default CardOportunidades